import { getSerializer } from '@shared/serializers/serializer';

export const issues = {
  type: 'issues',
  attributes: [
    'label',
    'comment',
    'isDeleted',
    'subLocation',
    'parentLocation',
    'createdBy',
    'createdAt',
    'qrcode',
    'status',
    'priority',
    'checklist',
    'company',
    'questionId',
    'pictures',
    'address'
  ],
};

export const IssuesSerializer = getSerializer(issues);
